import * as React from 'react';
import { StreetAddressViewModel } from './StreetAddress';

type Props = {
    address: StreetAddressViewModel | null;
}

export default class DisplayAddress extends React.PureComponent<Props> {

    public render() {
        if (!this.props.address) return null;
        return <React.Fragment>
            {this.props.address.Line1}<br />
            {this.props.address.Line2}
            {this.props.address.Line2 && <br/>}
            {this.props.address.City + ', ' + this.props.address.State + ' ' + this.props.address.Zip}
        </React.Fragment>;
    }
}
